<template>
  <el-dialog
    title="请输入权限密钥"
    width="500px"
    :visible="visible"
    @close="handleCancle"
    @closed="reset"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="passForm" :rules="passRules" :model="passForm" label-width="80px">
      <el-form-item prop="password" label="权限密钥">
        <el-input type="password" v-model="passForm.password" placeholder="请输入密钥" />
      </el-form-item>
    </el-form>
    <el-row slot="footer" class="dialog-footer" type="flex" justify="center">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" @click="handleOk" :loading="btnLoading">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import validatePassApi from 'api/home/validatePass';
export default {
  data() {
    return {
      visible: false,
      btnLoading: false,
      passForm: {
        password: ''
      },
      passRules: {
        password: [{ required: true, max: 20, message: '请输入密钥，长度小于20', trigger: 'blur' }]
      },
      validatList: {
        1: { method: 'dealStatusChange' },
        2: { method: 'dealVersionStatusChange' },
        3: { method: 'serverStatusChange' },
        4: { method: 'sortStatusChange' },
        5: { method: 'sortsStatusChange' },
        6: { method: 'deviceTypeStatusChange' },
        7: { method: 'deviceTypeChange' },
        8: { method: 'deviceParameterStatusChange' },
        9: { method: 'deviceParameterChange' },
        10: { method: 'deviceBrandStatusChange' },
        11: { method: 'deviceBrandChange' },
        12: { method: 'deviceSeriesStatusChange' },
        13: { method: 'deviceSeriesChange' }
      },
      needData: {},
      methodType: 0,
      needCheckOperating: false
    };
  },
  methods: {
    init(data, type, needCheckOperating) {
      this.visible = true;
      this.needData = data;
      this.methodType = type;
      this.needCheckOperating = needCheckOperating;
    },
    handleOk() {
      this.$refs.passForm.validate(validated => {
        if (!validated) {
          return;
        }
        const data = { ...this.needData };
        this.validatList[this.methodType] &&
          this[this.validatList[this.methodType].method](
            data,
            this.passForm.password,
            this.needCheckOperating
          );
      });
    },
    handleCancle() {
      this.visible = false;
      //   this.$emit('back', false);
    },
    reset() {
      this.$refs.passForm.resetFields();
      this.needData = {};
      this.methodType = 0;
      this.btnLoading = false;
    },
    // 协议状态
    dealStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDealStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 版本状态
    dealVersionStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editVersionStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 服务器状态
    serverStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editServerStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 总端口状态
    sortsStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editSortsStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 端口状态
    sortStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editSortStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备类型状态修改
    deviceTypeStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceTypeStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备类型修改
    deviceTypeChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceType(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备品牌状态修改
    deviceBrandStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceBrandStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备品牌修改
    deviceBrandChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceBrand(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备系列状态修改
    deviceSeriesStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceSeriesStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 设备系列修改
    deviceSeriesChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceSeries(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 功能参数状态修改
    deviceParameterStatusChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceParameterStatus(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 功能参数修改
    deviceParameterChange(data, operatingPassword, needCheckOperating) {
      this.btnLoading = true;
      validatePassApi
        .editDeviceParameter(data, operatingPassword, needCheckOperating)
        .then(res => {
          this.isThrough(res);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    //验证回调
    isThrough(res) {
      if (res.data.code !== 200) {
        return;
      }
      this.$emit('back', true, this.methodType);
      this.visible = false;
    }
  }
};
</script>